export default function Narrative() {
  return (
    <section
      id="narrativ"
      data-testid="narrative-section"
      className="relative py-16 sm:py-24 lg:py-40 bg-cm-cream"
    >
      <div className="max-w-[1280px] mx-auto px-5 sm:px-10 lg:px-16 grid lg:grid-cols-12 gap-10 sm:gap-12 lg:gap-20 items-center">
        <div className="lg:col-span-5 order-2 lg:order-1 reveal">
          <div className="relative max-w-[480px] mx-auto rounded-sm overflow-hidden border border-cm-line bg-cm-surface shadow-[0_30px_60px_-30px_rgba(196,139,139,0.35)]">
            <img
              src="/brand/cm-landscape.jpg"
              alt="Lever du for at undgå det, du ikke vil have — eller for at skabe det, du længes efter?"
              loading="lazy"
              data-testid="narrative-image"
              className="w-full h-auto block transition-transform duration-[1600ms] hover:scale-[1.02]"
            />
          </div>
          <p className="mt-6 text-xs tracking-[0.3em] uppercase text-cm-ink-soft italic font-serif text-center max-w-[480px] mx-auto">
            <span className="text-cm-rose">— </span>
            Mellemrummet, hvor noget nyt fødes
          </p>
        </div>

        <div className="lg:col-span-7 order-1 lg:order-2 reveal">
          <span className="ornament" data-testid="narrative-eyebrow">
            <em>Min tilgang</em>
          </span>
          <h2
            data-testid="narrative-headline"
            className="font-serif text-cm-ink mt-8 text-[1.85rem] sm:text-4xl lg:text-[3rem] leading-[1.16] sm:leading-[1.12] tracking-[-0.005em] max-w-2xl"
          >
            Identitetskriser er ikke et tegn på{" "}
            <span className="marker">svaghed</span>.
          </h2>
          <div className="mt-10 space-y-6 text-cm-ink-soft leading-[1.85] max-w-xl">
            <p data-testid="narrative-paragraph">
              Jeg ser dig dér, hvor du er — også i det svære mellemrum, hvor det
              gamle ikke længere passer, og det nye endnu ikke er født.
            </p>
            <p>
              Som din coach hjælper jeg dig med at rydde op i dit indre landskab,
              så du kan bevæge dig{" "}
              <span className="text-cm-ink">
                fra reaktion til intention
              </span>
              . Fra <em>“hvorfor skete det?”</em> til{" "}
              <em>“hvad gør jeg nu?”</em>.
            </p>
          </div>

          <div className="mt-12 pt-10 border-t border-cm-line max-w-xl">
            <p className="font-serif italic text-cm-ink text-xl leading-relaxed">
              “Du er ikke dine tidligere erfaringer — du er dine valg herfra.”
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
